import React, { useState, useEffect, Children, useRef } from 'react';
import ApiCaller from '../../config/api';
import InfiniteScroll from 'react-infinite-scroll-component';
import Circular from '../Loader/Circular';
import useColors from '../../hooks/useColors';

// Here is how you can used it
// In your parent component where you want to use it, like this.
// hasMore and scrollItems both are the state defined in parent component where you are using this comp.
// FOR EXAMPLE ===

// const scrollDataHandler = (data) => {
//   let newData = data?.data?.data;
//   setScrollItems(prevItems => [...prevItems, ...newData]);
//   return newData
// }

{
    /* <LoadOnScroll
            endPoint={`/users?sortBy=firstName&sortOrder=asc&page=`}
            hasMore={hasMore}
            setHasMore={setHasMore}
            scrollItems={scrollItems}
            scrollDataHandler={scrollDataHandler}
            loading={
                <Circular
                    size={20}
                    color={colorPrimary}
                />
            }
            children={
                scrollItems?.map((i, index) => (
                    <div key={index}>
                        div - #{index}
                    </div>
                ))
}
/> */
}

const style = {
    height: 30,
    // border: "1px solid green",
    margin: 6,
    padding: 8,
};

const LoadOnScroll = ({
    endPoint,
    restQueryParams = '',
    loadingSpinner,
    scrollDataHandler,
    scrollItems,
    hasMore,
    setHasMore,
    height,
    children,
    endMessage,
    isFetchConditionally = false,
    stopHasMoreScenerioConditionally = false,
    hasChildren,
    scrollableTarget,
    scrollThreshold,
    callback,
    style,
    setShiftLoader = () => { },
    handlePaginationMetadata = () => { },
    loadMoreRef,
    key,
    restQueryOpenShiftParams,
    itsAllowOpen
}) => {
    const [page, setPage] = useState(1);
    const directCallRef = useRef(isFetchConditionally ? false : true);
    const fetchedRef = useRef(false);

    const { colorPrimary } = useColors();

    console.log(
        'stopHasMoreScenerioConditionally',
        stopHasMoreScenerioConditionally,
    );

    const fetchMoreData = async (conditionalPageCall) => {
        const pageNo = conditionalPageCall ? conditionalPageCall : page;
        setShiftLoader(true);
        try {
            let newData = [];

            if (itsAllowOpen) {
                const [normalRes, openShiftRes] = await Promise.all([
                    ApiCaller.Get(
                        endPoint
                            ? `${endPoint}?page=${pageNo}&${restQueryParams}`
                            : '',
                    ),
                    ApiCaller.Get(
                        endPoint
                            ? `${endPoint}?page=${pageNo}&${restQueryOpenShiftParams}`
                            : '',
                    ),
                ]);

                handlePaginationMetadata(normalRes?.data?.paginate);

                // merging normal + open shifts, tolerating a missing/renamed list
                const normalItems = Array.isArray(normalRes?.data?.data)
                    ? normalRes.data.data
                    : [];
                const openItems = Array.isArray(openShiftRes?.data?.data)
                    ? openShiftRes.data.data
                    : [];
                normalRes['data'] = {
                    ...normalRes?.data,
                    data: [...normalItems, ...openItems],
                };
                console.log(normalRes, 'here is all data');
                newData = (await scrollDataHandler(normalRes)) || [];
            } else {
                const res = await ApiCaller.Get(
                    endPoint
                        ? `${endPoint}?page=${pageNo}&${restQueryParams}`
                        : '',
                );

                handlePaginationMetadata(res?.data?.paginate);
                newData = (await scrollDataHandler(res)) || [];
            }

            if (newData?.length === 0) {
                setHasMore(false);
            } else {
                setPage((prevPage) => prevPage + 1);
                setHasMore(true);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setHasMore(false);
        } finally {
            // must always run, otherwise the scheduler keeps spinning
            setShiftLoader(false);
        }
    };

    useEffect(() => {
        if (loadMoreRef) {
            loadMoreRef.current = fetchMoreData;
        }
    }, [fetchMoreData, loadMoreRef]);

    // fetching on specific condition like filters or something then:
    // page is set to 1
    // callback to call from parent if any.
    // calling fetchMoreData with page 1 as state change not reflect immediately.
    useEffect(() => {
        if (isFetchConditionally) {
            setPage(1);
            fetchMoreData(1);
            directCallRef.current = false;
            callback();
        } else {
            directCallRef.current = true;
        }
    }, [isFetchConditionally]);

    useEffect(() => {
        if (!isFetchConditionally) {
            fetchMoreData();
        }
    }, []);

    return (
        <div className="w-full" style={style}>
            <InfiniteScroll
                key={key}
                dataLength={scrollItems?.length || 0}
                next={directCallRef?.current ? fetchMoreData : ''}
                hasMore={stopHasMoreScenerioConditionally ? false : hasMore}
                loader={
                    loadingSpinner ? (
                        <div className="text-center my-2">
                            {/* <Circular
                                color={colorPrimary || '#1E1E1F'}
                                size={25}
                            /> */}
                        </div>
                    ) : (
                        null
                    )
                }
                height={height}
                hasChildren={hasChildren}
                scrollableTarget={scrollableTarget}
                scrollThreshold={scrollThreshold}
                endMessage={
                    <p style={{ textAlign: 'center' }}>
                        <b>
                            {endMessage
                                ? endMessage
                                : 'Yay! You have seen it all'}
                        </b>
                    </p>
                }
            >
                {children}
            </InfiniteScroll>
        </div>
    );
};

export default React.memo(LoadOnScroll);
